/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './AssetsDisplay.module.scss';

@translate()
export default class AssetsDisplay extends React.Component<*> {
  render(): React.Element<*> {
    const { assets, reason, title, t } = this.props;

    return (
      <div className={styles['asset-display']}>
        <b>{title || t('general:contracts.labels.asset_to_be_extended')}:</b>
        <table>
          <tbody>
            <tr>
              <th>{t('general:assets.abbrs.number')}</th>
              <th>{t('general:manufacturer')}</th>
              <th>{t('general:model')}</th>
              <th>{t('general:description')}</th>
              <th>{t('general:labels.serial_number')}</th>
            </tr>
            {assets.map(asset => {
              return (
                <tr key={asset.id}>
                  <td>
                    <Link to={`/assets/${asset.id}`}>{asset.asset_number}</Link>
                  </td>
                  <td>{asset.manufacturer}</td>
                  <td>{asset.model}</td>
                  <td>{asset.description}</td>
                  <td>{asset.serial_number}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {reason && (
          <div className={styles['extension-reason']}>
            <b>{t('general:reasons.reason_for_extending_contract')}: </b>
            <br />
            <span>{reason}</span>
          </div>
        )}
      </div>
    );
  }
}

AssetsDisplay.propTypes = {
  assets: PropTypes.object.isRequired,
  reason: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func,
};
